import { Header } from "../component/home/Header";
import { Footer } from "../component/home/Footer";
// import { ChatbotWidget } from "../component/home/ChatbotWidget";
import { Hero } from "../component/contact-us/Hero";
import { ContactSection } from "../component/contact-us/ContactSection";
import { SecurityNote } from "../component/contact-us/SecurityNote";
import { ProjectCta } from "../component/contact-us/ProjectCta";

export function ContactUsPage() {
  return (
    <div className="min-h-screen w-full bg-white">
      <Header />

      <main>
        <Hero />
        <ContactSection />
        <SecurityNote />
        <ProjectCta />
      </main>

      <Footer />
      {/* <ChatbotWidget /> */}
    </div>
  );
}
